import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'wr-confirm-dialog',
  templateUrl: './custom-confirm-dialog.component.html',
})
export class CustomConfirmDialogComponent {
  @Input() title = 'Bestätigung';
  @Input() message = 'Sind Sie sicher, dass Sie fortfahren möchten?';
}

